<template>
  <div class="card next-activity-card">
    <p class="title" v-hover="onHoverOver">Volgende activiteit:</p>
    <div v-if="nextActivity" v-hover="onHoverOver">
      <p class="subtitle ">{{ formatDateMonthYear(nextActivity.plannedDate) }} - <span><i
          class="far fa-clock"></i></span>
        {{ formatHourMinutes(nextActivity.plannedDate) }}</p>
    </div>
    <div v-else>
      Er zijn nog geen geplande activiteiten voor deze buddy
    </div>
    <v-button class="mt-3" button-text="Spel starten" :enabled="true" @click="startActivity"
              v-hover="onHoverOverButton"></v-button>
    <button v-if="showFinishYearButton" @click="endGameClicked" class="btn btn-link end-activity-btn mt-3">Spel
      Afronden
    </button>

    <HoverInfo :show="hoveringOver" :content="'Geplande Activiteiten'" :offset-y="12" :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverButton" :content="'Direct een spel starten vanuit het spelplatform'" :offset-y="12"
               :offset-x="12"></HoverInfo>
  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";
import DateFormatter from "@/mixins/DateFormatter";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "AgendaNextActivity",
  components: {HoverInfo, VButton},
  mixins: [ DateFormatter ],
  props: {
    nextActivity: Object,
    buddyId: Number,
    showFinishYearButton: Boolean,
  },
  data: function () {
    return {
      hoveringOver: false,
      hoveringOverButton: false,
    }
  },
  emits: [ "startActivityClicked" ],
  methods: {
    startActivity()
    {
      this.$emit("startActivityClicked");
    },
    endGameClicked()
    {
      this.$router.push({ name: 'end-game-confirmation', params: { id: this.buddyId } });
    },
    onHoverOver(state) {
      this.hoveringOver = state;
    },
    onHoverOverButton(state) {
      this.hoveringOverButton = state;
    }


  }
}
</script>

<style lang="scss" scoped>
.next-activity-card
{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 21px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.end-activity-btn {
  color: #FF5A31;
  font-weight: 500;
  text-decoration: underline;
}
</style>